var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{attrs:{"no-body":""},on:{"submit":function($event){$event.stopPropagation();$event.preventDefault();return _vm.handleSubmit.apply(null, arguments)}}},[_c('b-tabs',{attrs:{"card":""}},[_c('b-table',{attrs:{"items":_vm.uitpekelItemLijst,"fields":_vm.fields,"small":"","striped":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }